/* Pure Lust — Starter builder ("Net begonnen")
 * Elke stap heeft een aan/uit-toggle en een klein keuzemenu (radio's).
 * Berekent live hoeveel producten zijn gekozen, markeert de bijpassende
 * deal-tier, en voegt de geselecteerde varianten toe aan de winkelmand.
 * De korting zelf wordt door een Shopify automatische korting toegepast —
 * dit script rekent geen korting uit, het toont alleen de stimulans.
 */
(function () {
  function formatEuro(cents) {
    return '€' + (cents / 100).toFixed(2).replace('.', ',');
  }

  function init() {
    var root = document.querySelector('.pl-sb');
    if (!root) return;

    var steps = Array.prototype.slice.call(root.querySelectorAll('[data-pl-sb-step]'));
    if (!steps.length) return;

    steps.forEach(function (step) {
      var toggle = step.querySelector('[data-pl-sb-toggle]');
      if (toggle) {
        toggle.addEventListener('change', function () {
          step.setAttribute('data-included', toggle.checked ? 'true' : 'false');
          recompute();
        });
      }

      var options = Array.prototype.slice.call(step.querySelectorAll('[data-pl-sb-option]'));
      options.forEach(function (opt) {
        opt.addEventListener('change', function () {
          options.forEach(function (o) {
            o.closest('.pl-sb__option').classList.toggle('is-selected', o === opt);
          });
          recompute();
        });
      });

      var optionCards = Array.prototype.slice.call(step.querySelectorAll('.pl-sb__option'));
      optionCards.forEach(function (card) {
        var infoToggle = card.querySelector('[data-pl-sb-info-toggle]');
        var infoPanel = card.querySelector('[data-pl-sb-info-panel]');
        if (!infoToggle || !infoPanel) return;
        infoToggle.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var open = infoPanel.classList.toggle('is-open');
          infoToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
        });
        infoPanel.addEventListener('click', function (e) { e.stopPropagation(); });
      });

      var optionsWrap = step.querySelector('[data-pl-sb-options-wrap]');
      var optionsTrack = step.querySelector('[data-pl-sb-options]');
      var optionsNext = step.querySelector('[data-pl-sb-options-next]');
      if (optionsTrack && optionsNext) {
        var updateArrow = function () {
          var maxScroll = optionsTrack.scrollWidth - optionsTrack.clientWidth;
          var atEnd = maxScroll <= 4 || optionsTrack.scrollLeft >= maxScroll - 4;
          optionsNext.classList.toggle('is-hidden', atEnd);
          if (optionsWrap) {
            if (atEnd) optionsWrap.setAttribute('data-at-end', '');
            else optionsWrap.removeAttribute('data-at-end');
          }
        };
        optionsNext.addEventListener('click', function () {
          var opts = Array.prototype.slice.call(optionsTrack.querySelectorAll('.pl-sb__option'));
          var current = optionsTrack.scrollLeft;
          var next = opts.filter(function (o) { return o.offsetLeft > current + 4; })[0];
          var target = next ? next.offsetLeft : optionsTrack.scrollWidth;
          optionsTrack.scrollTo({ left: target, behavior: 'smooth' });
        });
        optionsTrack.addEventListener('scroll', updateArrow);
        window.addEventListener('resize', updateArrow);
        updateArrow();
      }
    });

    function recompute() {
      var includedSteps = steps.filter(function (s) { return s.getAttribute('data-included') !== 'false'; });
      var ids = [];
      var total = 0;

      includedSteps.forEach(function (step) {
        var selected = step.querySelector('[data-pl-sb-option]:checked');
        if (selected) {
          ids.push(selected.value);
          total += parseInt(selected.getAttribute('data-price'), 10) || 0;
        }
      });

      var countEl = root.querySelector('[data-pl-sb-count]');
      if (countEl) countEl.textContent = ids.length;

      /* Kortingspercentage is puur informatief — de echte korting wordt door
         een Shopify automatische korting toegepast bij het afrekenen. */
      var discountPct = ids.length >= 3 ? 15 : (ids.length === 2 ? 10 : 0);
      var discountedTotal = Math.round(total * (100 - discountPct) / 100);
      var savings = total - discountedTotal;

      var totalEl = root.querySelector('[data-pl-sb-total]');
      if (totalEl) totalEl.textContent = ids.length ? formatEuro(discountedTotal) : '—';

      var wasRow = root.querySelector('[data-pl-sb-was-row]');
      var wasEl = root.querySelector('[data-pl-sb-was]');
      if (wasRow && wasEl) {
        if (ids.length && savings > 0) {
          wasEl.textContent = formatEuro(total);
          wasRow.hidden = false;
        } else {
          wasRow.hidden = true;
        }
      }

      var savingsEl = root.querySelector('[data-pl-sb-savings]');
      if (savingsEl) {
        if (ids.length && savings > 0) {
          savingsEl.textContent = 'Je bespaart ' + formatEuro(savings) + ' (' + discountPct + '%)';
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }

      var tiers = Array.prototype.slice.call(root.querySelectorAll('[data-pl-sb-tier]'));
      var bestTier = null;
      var bestNeed = -1;
      tiers.forEach(function (tier) {
        var need = parseInt(tier.getAttribute('data-pl-sb-tier'), 10);
        if (ids.length >= need && need > bestNeed) {
          bestNeed = need;
          bestTier = tier;
        }
      });
      tiers.forEach(function (tier) { tier.classList.toggle('is-active', tier === bestTier); });

      /* Voortgangsbalk: mikt altijd op de kortingsdrempel (3 producten), ook als
         er meer dan 3 stappen zijn — extra stappen zijn optionele toevoegingen
         zonder eigen kortingstrede. */
      var maxSteps = 3;
      var pct = maxSteps > 1 ? Math.max(0, Math.min(1, (ids.length - 1) / (maxSteps - 1))) * 100 : 0;
      var fill = root.querySelector('[data-pl-sb-progress-fill]');
      if (fill) fill.style.width = pct + '%';
      root.querySelectorAll('[data-pl-sb-progress-point]').forEach(function (point) {
        var n = parseInt(point.getAttribute('data-pl-sb-progress-point'), 10);
        point.classList.toggle('is-reached', ids.length >= n);
      });

      var msgEl = root.querySelector('[data-pl-sb-progress-msg]');
      if (msgEl) {
        var key = 'data-msg-' + Math.max(0, Math.min(maxSteps, ids.length));
        msgEl.textContent = msgEl.getAttribute(key) || '';
      }

      var btn = root.querySelector('[data-pl-sb-add]');
      if (btn) {
        btn.setAttribute('data-variant-ids', ids.join(','));
        btn.disabled = ids.length === 0;
      }
    }

    recompute();
    initAdd(root);
  }

  function initAdd(root) {
    var btn = root.querySelector('[data-pl-sb-add]');
    if (!btn) return;

    btn.addEventListener('click', function () {
      var raw = btn.getAttribute('data-variant-ids') || '';
      var ids = raw.split(',').map(function (s) { return s.trim(); }).filter(Boolean);
      if (!ids.length) return;

      btn.setAttribute('data-state', 'loading');
      addSequentially(ids.slice(), [], []).then(function (result) {
        var added = result.added;
        var skipped = result.skipped;
        if (added.length === 0) {
          btn.removeAttribute('data-state');
          showNotice('Geen producten beschikbaar — probeer later opnieuw.');
          return;
        }
        btn.setAttribute('data-state', 'added');
        updateCartCount();
        if (skipped.length > 0) {
          showNotice(skipped.length === 1
            ? 'Eén product was uitverkocht en is overgeslagen — de rest zit in je winkelmand.'
            : skipped.length + ' producten waren uitverkocht en zijn overgeslagen — de rest zit in je winkelmand.');
        }
        setTimeout(function () {
          window.location.href = '/cart';
        }, skipped.length > 0 ? 2400 : 900);
      });
    });
  }

  function addSequentially(remaining, added, skipped) {
    if (remaining.length === 0) {
      return Promise.resolve({ added: added, skipped: skipped });
    }
    var id = remaining.shift();
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(id, 10), quantity: 1 })
    })
    .then(function (r) {
      if (r.ok) {
        added.push(id);
      } else {
        skipped.push(id);
      }
      return addSequentially(remaining, added, skipped);
    })
    .catch(function () {
      skipped.push(id);
      return addSequentially(remaining, added, skipped);
    });
  }

  function showNotice(msg) {
    var n = document.createElement('div');
    n.className = 'pl-sb__notice';
    n.setAttribute('style', 'position:fixed;left:50%;bottom:28px;transform:translateX(-50%) translateY(12px);background:#2b2120;color:#fff;padding:12px 20px;border-radius:8px;font-family:Poppins,sans-serif;font-size:13px;box-shadow:0 12px 30px rgba(0,0,0,.25);opacity:0;transition:opacity .3s ease, transform .3s ease;z-index:999;max-width:88vw;text-align:center;');
    n.textContent = msg;
    document.body.appendChild(n);
    requestAnimationFrame(function () {
      n.style.opacity = '1';
      n.style.transform = 'translateX(-50%) translateY(0)';
    });
    setTimeout(function () {
      n.style.opacity = '0';
      setTimeout(function () { n.remove(); }, 400);
    }, 3500);
  }

  function updateCartCount() {
    fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-pl-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
